export default "__VITE_ASSET__DsgQMNj9__"